export default __webpack_public_path__ + "static/media/logo_stift.ba26a4d2.jpeg";